import { render, staticRenderFns } from "./ContractMainInfo.vue?vue&type=template&id=351699fc&scoped=true&"
import script from "./ContractMainInfo.vue?vue&type=script&lang=js&"
export * from "./ContractMainInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351699fc",
  null
  
)

export default component.exports